function getResolution(settings) {
  
  var res = settings.camera.resolution;
  var size = res.split('x');
  if (size.length === 2) {
    var w = parseInt(size[0]);
    var h = parseInt(size[1]);
    if (w > 0 && h > 0) {
      return {width: w, height: h};
    }
  }
  throw new Error('Invalid "resolution" in /camera/resolution');
}

module.exports = getResolution;


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-settings-check/utils/getResolution.js
// module id = 445
// module chunks = 0